import React from 'react';
import { captureMessage, captureError, setUser } from '../utils/sentry';

/**
 * Composant de test pour Sentry
 * À SUPPRIMER après avoir vérifié que Sentry fonctionne
 */
const SentryTest = () => {
  const testMessage = () => {
    captureMessage('Test Sentry - Message INFO', 'info', {
      testType: 'message',
      timestamp: new Date().toISOString()
    });
    alert('Message envoyé à Sentry ! Vérifiez votre dashboard.');
  };

  const testWarning = () => {
    captureMessage('Test Sentry - Avertissement', 'warning', {
      testType: 'warning',
      action: 'test-button-clicked'
    });
    alert('Warning envoyé à Sentry ! Vérifiez votre dashboard.');
  };

  const testError = () => {
    try {
      throw new Error('Test Sentry - Erreur volontaire pour tester');
    } catch (error) {
      captureError(error, {
        testType: 'error',
        component: 'SentryTest',
        userAction: 'clicked-test-error-button'
      });
      alert('Erreur envoyée à Sentry ! Vérifiez votre dashboard.');
    }
  };

  const testUserContext = () => {
    setUser({
      id: 'test-user-123',
      email: 'test@example.com',
      username: 'Test User',
      role: 'super_admin'
    });

    captureMessage('Test avec contexte utilisateur', 'info');
    alert('Message avec user context envoyé ! Vérifiez dans Sentry que l\'utilisateur est bien associé.');
  };

  const testCrash = () => {
    // Ceci va crash le composant et être capturé par ErrorBoundary
    throw new Error('Test ErrorBoundary - Crash volontaire du composant React');
  };

  return (
    <div className="p-8 max-w-2xl mx-auto">
      <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6">
        <div className="flex">
          <div className="flex-shrink-0">
            <svg className="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
            </svg>
          </div>
          <div className="ml-3">
            <p className="text-sm text-yellow-700">
              <strong>Page de test Sentry</strong> - À supprimer après vérification
            </p>
          </div>
        </div>
      </div>

      <h1 className="text-2xl font-bold mb-6">Tests Sentry</h1>

      <div className="space-y-3">
        <button
          onClick={testMessage}
          className="w-full bg-blue-500 text-white px-4 py-3 rounded-lg hover:bg-blue-600 transition"
        >
          📨 Tester un message INFO
        </button>

        <button
          onClick={testWarning}
          className="w-full bg-yellow-500 text-white px-4 py-3 rounded-lg hover:bg-yellow-600 transition"
        >
          ⚠️ Tester un WARNING
        </button>

        <button
          onClick={testError}
          className="w-full bg-orange-500 text-white px-4 py-3 rounded-lg hover:bg-orange-600 transition"
        >
          ❌ Tester une ERREUR
        </button>

        <button
          onClick={testUserContext}
          className="w-full bg-purple-500 text-white px-4 py-3 rounded-lg hover:bg-purple-600 transition"
        >
          👤 Tester avec contexte utilisateur
        </button>

        <button
          onClick={testCrash}
          className="w-full bg-red-500 text-white px-4 py-3 rounded-lg hover:bg-red-600 transition"
        >
          💥 Tester ErrorBoundary (crash React)
        </button>
      </div>

      <div className="mt-8 p-4 bg-gray-50 rounded-lg">
        <h2 className="font-semibold mb-2">Instructions :</h2>
        <ol className="text-sm space-y-1 list-decimal list-inside text-gray-700">
          <li>Configurez vos DSN dans .env.local</li>
          <li>Changez REACT_APP_ENVIRONMENT=production dans .env.local</li>
          <li>Redémarrez l'app (npm start)</li>
          <li>Cliquez sur les boutons ci-dessus</li>
          <li>Vérifiez votre dashboard Sentry.io</li>
          <li>Les erreurs apparaissent sous "Issues"</li>
          <li>Remettez REACT_APP_ENVIRONMENT=development après</li>
        </ol>
      </div>
    </div>
  );
};

export default SentryTest;
